var _effectorFileName = "/src/shared/components/ui/skeleton.tsx";
import { cn } from '@/shared/lib/cn';
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-primary/10', className)} {...props} />;
}
export { Skeleton };